import { render, staticRenderFns } from "./industries-carousel.vue?vue&type=template&id=159850fe&"
import script from "./industries-carousel.vue?vue&type=script&lang=js&"
export * from "./industries-carousel.vue?vue&type=script&lang=js&"
import style0 from "./industries-carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports